<template>
<div class="row justify-content-md-center">

	<div class="col-12 col-xl-8">

		<div class="row">
			<div class="col">

				<b-form-group class="pull-right">
					<b-btn variant="primary"
					       v-b-tooltip.hover
					       title="Categorie toevoegen"
					       exact
					       :to="{ name: 'categoryAdd' }">
						<i class="fa fa-fw fa-plus"></i>
					</b-btn>
					<b-btn variant="outline-secondary"
					       v-b-tooltip.hover
					       title="Terug"
					       exact
					       :to="{ name: 'Landingpage' }">
						<i class="fa fa-fw fa-reply"></i>
					</b-btn>
				</b-form-group>

				<h1 class="display-4">Categorieën beheer</h1>

				<b-alert v-if="error"
				         variant="danger"
				         show>{{ error }}</b-alert>

				<b-pagination-nav :link-gen="linkGen"
				                  :number-of-pages="categories.last_page"
				                  :value="categories.current_page"
				                  use-router
				                  align="right" />
			</div>
		</div>


		<partial-loader :loading="isFetching"></partial-loader>

		<b-table v-if="!isFetching"
				 
				striped
				hover
				show-empty
				:items="categories.data"
				:fields="fields"
				:per-page="parseInt(categories.per_page)"
				:sort-by.sync="sortBy"
				:sort-desc.sync="sortDesc"
				:busy="isFetching"
				:empty-text="$t('category.listEmptyText')"
				:empty-filtered-text="$t('category.listEmptyFilteredText')">

			<template v-slot:cell(auction_date)="row">
				<template v-if="row.item.auction_date">{{ row.item.auction_date | smallDate }}</template>
				<template v-else> - </template>
			</template>

			<template v-slot:cell(actions)="row">
	 			<b-btn-group class="pull-right">
					<b-btn variant="outline-danger" @click="showDeleteModal(row.item)"><i class="fa fa-fw fa-trash"></i></b-btn>
					<b-btn variant="outline-primary" :to="{ name: 'categoryEdit', params: { categoryId: row.item.id } }"><i class="fa fa-fw fa-edit"></i></b-btn>
				</b-btn-group>
	 		</template>

		</b-table>

		<b-pagination-nav :link-gen="linkGen"
		                  :number-of-pages="categories.last_page"
		                  :value="categories.current_page"
		                  use-router
		                  align="right" />

		<delete-dialog-modal ref="deleteModal"
		                     :delete-name="selectedDeleteCategoryName"
		                     :item="selectedDeleteCategory"
		                     :isDeleting="isDeleting"
		                     @confirm="deleteCategory"></delete-dialog-modal>
	</div>
</div>
</template>

<script>
import { isNil } from 'lodash';
import CategoryService from '@/services/category-service.js';
import PartialLoader from '@/components/elements/PartialLoader';
import DeleteDialogModal from '@/components/elements/Edit/DeleteDialogModal';
import { flashSuccess } from '@/helpers/flash-message-helper';
import { smallDate } from '@/filters/date-filters';

export default {
	components: {
		PartialLoader,
		DeleteDialogModal
	},
	data() {
		return {
			isFetching: true,
			isDeleting: false,
			categories: {},
			error: null,
			fields: [
				{ key:'title', label: 'Titel' },
				{ key:'abbreviation', label: 'Afkorting' },
				{ key:'slug', label: 'Code' },
				{ key:'start_auction_order_number', label: this.$t('category.startAuctionOrderNumber') },
				{ key:'auction_date', label: this.$t('category.startTime') },
				{ key:'actions', label: this.$t('common.actions'), class: 'text-right' }
			],
			currentPage: 1,
			sortBy: 'id',
			sortDesc: true,
			selectedDeleteCategory: false
		}
	},
	filters: {
		smallDate
	},
	computed: {
		selectedDeleteCategoryName() {
			if (!this.selectedDeleteCategory) return '';

			return 'de categorie ' + this.selectedDeleteCategory.title;
		}
	},
	watch: {
		'$route': 'fetchData'
	},
	methods: {
		initialize() {
			this.fetchData();
		},
		linkGen(pageNumber) {
			return '?page=' + pageNumber;
		},
		fetchData() {
			this.isFetching = true;

			const query = this.$route.query;
			const currentPage = Number.parseInt(query.page);
			this.currentPage = isNaN(currentPage) ? 1 : currentPage;

			const params = {
				page: this.currentPage,
				sort: this.sortBy,
				order: this.sortDesc ? 'desc' : 'asc'
			}

			return CategoryService.getAll(params).then(response => {
				this.isFetching = false;
				this.categories = response;
			}).catch(error => {
				this.isFetching = false;
				this.error = error.message;
			});
		},
		/**
		 * Show delete modal for the category
		 * @param  {Object} category
		 */
		showDeleteModal(category) {
			this.selectedDeleteCategory = category;
			this.$refs.deleteModal.show();
		},
		deleteCategory(category) {
			this.isDeleting = true;

			return CategoryService.delete(category.id).then(response => {
				this.$refs.deleteModal.hide()
				this.isFetching = false;
				this.isDeleting = false;
				flashSuccess(this.$t('category.deleteSuccess'));
				this.fetchData();
			}).catch(error => {
				this.$refs.deleteModal.hide()
				this.isFetching = false;
				this.isDeleting = false;
				this.error = error.message;
			});
		}
	},
	mounted() {
		this.initialize();
	}
}
</script>



// WEBPACK FOOTER //
// CategoryList.vue?58236940